import React from "react";
import Dashboard from "../../components/Dashboard/Dashboard";

function UserDashboard() {
  return (
    <>
      <Dashboard />
    </>
  );
}

export default UserDashboard;
